import HttpService from "../baseHttp";
// 多规格补货规则列表
export const HttpGetReplenishList = (data) => HttpService.get("/api/v2/productReplenishmentRule/findByPage", { params: data });
// 多规格补货规则详情页
export const HttpGetReplenishDetail = (data) => HttpService.get("/api/v2/productReplenishmentRule/getById", { params: data });
// 新增、编辑
export const HttpSaveReplenishDetail = (data) => HttpService.post("/api/v2/productReplenishmentRule/save", data, { headers: { "Content-Type": "application/json" } });
// 操作历史
export const HttpSysOpLog = (data = {}, config) => HttpService.get('/api/v1/SysOpLog/findByPage', { params: data });
// 删除、批量删除
export const HttpReplenishDelete = (data) => HttpService.get("/api/v2/productReplenishmentRule/del", { params: data });
// 根据id获取产品详情
export const HttpGetDetailByProductId = (data) => HttpService.get("/api/v1/Product/getById", { params: data });